import { SubscriptionExpiredModal } from './SubscriptionExpiredModal';

export default SubscriptionExpiredModal;
